import gql from 'graphql-tag';
export default gql`
  fragment customerInfo on Customer {
    id
    name
    code
    address
    totalDebt
    dueDebt
    inWeekDebt
    paymentDeadline
    blocked
    blockWarning
    phone
    city
    category
    dailyOrderCount
    dailyVisitsCount
    customersGroup
    specCategory
    visitDay
    visitFrequency
    lastOrderDate
    discounts
    isSale
    isVisit
    isConsignment
    routeSchedules {
      id
      salesman
      dayOfVisit
      frequency
      nextVisit
      lastTimeOrder
      isSale
      isVisit
    }
    location {
      lng
      lat
    }
    route {
      nextVisit
      dayOfVisit
    }
    parent {
      id
      code
      name
    }
    deliveryDays {
      mon
      tue
      wed
      thu
      fri
      sat
      sun
      division
      divisionName
    }
  }
`;